module.exports = __webpack_public_path__ + "img/平安银行.ae4528ab.png";